import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetSmartLockNonceResData } from "./GetSmartLockNonceResData";

const ENDPOINT = "/otc/smartlock/nonce";

export class GetSmartLockNonceCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    params: GetSmartLockNonceReqData = null;

    constructor(installationName: string, machineSerialNumber: string) {
        super();
        this.params = new GetSmartLockNonceReqData(installationName, machineSerialNumber);
    }

    public async execute(): Promise<GetSmartLockNonceResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new GetSmartLockNonceResData(res);
    }
}

export class GetSmartLockNonceReqData {
    installationName: string;
    machineSerialNumber: string;
    constructor(installationName: string, machineSerialNumber: string) {
        this.installationName = installationName;
        this.machineSerialNumber = machineSerialNumber;
    }
}
